import React from 'react';
import ScrollableAnchor from 'react-scrollable-anchor';
import styled from 'styled-components';
import rmq from 'styled-rmq';
import testimonials from '../../data/testimonials.js';
import Desc from '../Basic/Desc';
import Heading from '../Basic/Heading';

const Wrap = styled.div`
	display: flex;
	max-width: 144rem;
	margin: 0 auto;
	padding: 9rem 0;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
`;

const Testimonial = styled.blockquote`
	max-width: 36rem;
	border-radius: 8px;
	margin: ${props => props.theme.vr * 1}rem;
	padding: ${props => props.theme.vr * 1.15}rem;
	background: #fff;
	color: ${props => props.theme.blue2};
	text-align: left;
	box-shadow: 0 2px 4px 0 rgba(14, 30, 37, 0.12);
	transition: all 0.4s ease;

	&:hover {
		box-shadow: 0 1rem 5rem 0 rgba(14, 30, 37, 0.12);
	}

	${rmq('800')} {
		max-width: 30rem;
		margin: 0.5rem;
	}

	${rmq('625')} {
		max-width: 25rem;
	}
	${rmq('525')} {
		max-width: 45rem;
		margin: 1rem;
	}
`;
const Text = styled.p`
	margin: 0;
	font-size: 1.6rem;

	a {
		color: inherit;
		text-decoration: none;
		transition: 0.4s all ease-out;
		border-bottom: 1px dotted ${props => props.theme.blue3};

		&:hover {
			border-bottom: 1px dotted ${props => props.theme.c2};
		}
	}
`;
const Cite = styled.cite`
	display: table;
	width: 100%;
	margin-top: auto;
	padding-top: ${props => props.theme.vr * 1}rem;
	color: ${props => props.theme.blue2};

	img {
		float: left;
		border-radius: 50%;
		margin-right: ${props => props.theme.vr * 1}rem;
		width: ${props => props.theme.vr * 3}rem;
		height: ${props => props.theme.vr * 3}rem;
		background: #fff;
	}
`;
const Name = styled.a`
	font-family: ${props => props.theme.f2};
	font-size: ${props => props.theme.vr * 1}rem;
	text-decoration: none;
	color: inherit;
	font-style: normal;

	small {
		display: block;
		font-weight: 400;
		opacity: 0.9;

		${rmq('ml')} {
			font-size: 1.1rem;
		}
	}
`;

export default ({ cap }) => {
	// Max testimonials or 999.
	const capNumber = cap ? parseInt(cap) : 9999;
	return (
		<>
			<ScrollableAnchor id="reviews">
				<span />
			</ScrollableAnchor>
			<Heading>Take Their Word for It</Heading>
			<Desc>You don't have to take my word for it. Some nice folks have said some nice things!</Desc>
			<Wrap className="grid">
				{testimonials.map((testimonial, i) => {
					if (i < capNumber) {
						return (
							<Testimonial className="grid-item" key={i}>
								<Text dangerouslySetInnerHTML={{ __html: testimonial.text }} />
								<Cite>
									<img
										className="lazyload"
										data-src={testimonial.img}
										alt={testimonial.name}
										loading="lazy"
									/>
									<Name href={testimonial.link} target="_blank" rel="nofollow noopener noreferrer">
										{testimonial.name}
										<small>{testimonial.bio}</small>
									</Name>
								</Cite>
							</Testimonial>
						);
					} else {
						return false;
					}
				})}
			</Wrap>
		</>
	);
};
